import { useEffect, useRef, useState } from 'react';
import "./email-popup.scss";

const EmailPopup = props => {
    const [ email, setEmail ] = useState( props.email )
    const [ nick, setNick ] = useState( props.nick )
    const [ emailError, setEmailError ] = useState( '' )
    const [ nickError, setNickError ] = useState( '' )
    const [ includeNewsletter, setIncludeNewsletter ] = useState( !! props.includeNewsletter )
    const emailRef = useRef()

    useEffect( () => {
        setEmail( props.email )
    }, [ props.email ] )
    useEffect( () => {
        setNick( props.nick )
    }, [ props.nick ] )
    useEffect( () => {
        setIncludeNewsletter( !! props.includeNewsletter )
    }, [ props.includeNewsletter ] )
    useEffect( () => {
        emailRef.current.focus()
    }, [] )

    const onSubmit = () => {
        let hasError = false
        if ( ! /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( email ) ) {
            setEmailError( 'Please enter a valid email address' )
            hasError = true
        } else {
            setEmailError( '' )
        }
        if ( ! /^[A-Za-z0-9]{3}$/.test( nick ) ) {
            setNickError( 'Please enter 3 characters containing only letters or numbers' )
            hasError = true
        } else {
            setNickError( '' )
        }

        if ( ! hasError ) {
            props.onChange( email, nick, !! includeNewsletter )
        }
    }

    return (
        <div className="email-popup">
            <h2>Welcome to Stackable's Flappy Block Game!</h2>
            <p>In order to participate in the game and raffle, please enter your email that is (or will be) associated with your Stackable account. Only scores and tickets that are connected with valid <strong>Stackable Premium accounts</strong> will be included in the raffle.</p>
            <label>
                <h3>Your Email <span>*</span></h3>
                <input 
                    ref={ emailRef }
                    className="email-popup__input email-popup__input-email"
                    type="email"
                    placeholder="your@email.com"
                    required 
                    value={ email } 
                    onChange={ ev => setEmail( ev.target.value ) }
                    onKeyDown={ ev => {
                        if ( ev.key === 'Enter' ) {
                            onSubmit()
                        }
                    } }
                />
                { emailError && <span className="email-popup__error">{ emailError }</span> }
                <span>This is the email you used to purchase Stackable. This will not be public.</span>
            </label>
            <label>
                <h3>Highscore Nickname <span>*</span></h3>
                <input 
                    className="email-popup__input email-popup__input-nick"
                    type="text"
                    placeholder="BEN"
                    minLength="3"
                    maxLength="3"
                    pattern="[A-Za-z0-9]{3}"
                    required
                    value={ nick } 
                    onChange={ ev => setNick( ev.target.value ) } 
                    onKeyDown={ ev => {
                        if ( ev.key === 'Enter' ) {
                            onSubmit()
                        }
                    } }
                />
                { nickError && <span className="email-popup__error">{ nickError }</span> }
                <span>3 Letters or numbers. This is used to show your highscore.</span>
            </label>
            <label className="email-popup__checkbox">
                <input type="checkbox" onChange={ () => setIncludeNewsletter( v => ! v ) } checked={ !! includeNewsletter } /> Include me in the newsletter if I'm not yet there
            </label>
            <button className="email-popup__submit" onClick={ onSubmit }>Submit</button>
        </div>
    )
}

EmailPopup.defaultProps = {
    onChange: () => {},
    email: '',
    nick: '',
    includeNewsletter: false,
}

export default EmailPopup